import { PaginationFiltersState } from "../../core/models/entities";

export const initialStatePaginationFilter: PaginationFiltersState = {};

